export default __webpack_public_path__ + "static/media/recruiter-bot.e27582e8.svg";